<template>
  <div>
    <Checklist v-if="showChecklist" :id="id" />
    <Evaluation v-if="showEvaluation" :id="id" />
  </div>
</template>

<script>
import { get } from "lodash";
import Checklist from "./Checklist.vue";
import Evaluation from "./Evaluation.vue";

export default {
  name: "Root",

  components: {
    Checklist,
    Evaluation
  },

  data: () => {
    return {
      type: "",
      id: ""
    };
  },

  computed: {
    showChecklist() {
      return this.type === "checklist";
    },
    showEvaluation() {
      return this.type === "evaluation";
    }
  },

  watch: {
    $route() {
      this.setParams();
    }
  },

  beforeMount() {
    this.setParams();
  },

  methods: {
    setParams() {
      const { query } = this.$route;

      this.type = get(query, "type", "");
      this.id = get(query, "id", "");
    }
  }
};
</script>
